import { createSelector } from "@reduxjs/toolkit";
import { SET_CONTEXT_MENU_OPTIONS, SET_CONTEXT_MENU_COORDS, SET_CONTEXT_MENU_OPENED } from "../actions/contextMenuActions";

export const isContextMenuOpened = createSelector(
    state => state.contextMenuState,
    contextMenuState => contextMenuState.opened
);

export const getContextMenuCoords = createSelector(
    state => state.contextMenuState,
    contextMenuState => contextMenuState.coords
);

export const getContextMenuOptions = createSelector(
    state => state.contextMenuState,
    contextMenuState => contextMenuState.options
);

const INITIAL_STATE = {
    opened: false,
    coords: { x: 0, y: 0 },
    options: undefined
}

export const contextMenuState = (state = INITIAL_STATE, action) => {
    switch(action.type) {
        case SET_CONTEXT_MENU_OPENED:
            return {...state, opened: action.payload};
        case SET_CONTEXT_MENU_COORDS:
            return {...state, coords: action.payload};
        case SET_CONTEXT_MENU_OPTIONS:
            return {...state, options: action.payload};
        default:
            return state;
    }
}